
import { defineComponent } from 'vue';
import loginAndOut from '@/components/Common/LoginAndOut.vue';

export default defineComponent({
  components: {
    loginAndOut,
  },
  name: 'TopBar',
  setup() {},
});
